import React from "react";
import {connect, useDispatch} from "react-redux";
import {AppState} from "../RootReducer";
import {BonusConfig, BonusUpcomingOffer, ContributionProduct} from "../http/protocol";
import Translator from "../Translator";
import "./BonusPage.scss";
import {t} from "../i18n";
import {RouteComponentProps, withRouter} from "react-router";
import UFO from "../assets/cow_ufo.png";

import {BrandA} from "../ui/buttons/buttons";
import {showCashier} from "../payments/DepositActions";

import {setActiveCurrency} from "../user/UserActions";
import {AccountCard} from "../ui/AccountUI";
import {setDisplayTermsForBonusConfigId} from "./BonusActions";


export const NextBonuses = ( props : {bonuses : BonusUpcomingOffer[], activeCurrency:string, dbt:string, setActiveCurrency(cc:string): typeof setActiveCurrency, firstNextCurrency:string}) => {
    const next:boolean = !!props.bonuses.find((bonus : any) => bonus.bonusConfig!.monetaryConfig?.currencyCode === props.activeCurrency);
    
    let bonuses:any[] = [];
    bonuses =  props.bonuses.filter(b => b.bonusConfig!.monetaryConfig?.currencyCode == props.activeCurrency).map( b => (
            <NextBonus  key={b.bonusConfig!.id} bonus={b.bonusConfig} dbt={props.dbt}/>
            )
        );
    return (

        <>
            {next && <>
                <h3 className={"section"}>{t("bonus.next")}</h3>
                {bonuses}
            </>}
            <div className={"row notFound-content"}>
                {bonuses.length === 0 && (
                    <div className="notFound-wrapper">
                        <img className={"notFound"} src={UFO} alt={"Not found"}
                             style={{background: `url(${UFO}) no-repeat`, backgroundSize: 'cover'}}/>
                        {props.firstNextCurrency.length > 0 && (
                            <>
                                <br/>
                                <p>{t("bonus.bonusOfferOther", {currencyCode:props.firstNextCurrency})}</p>
                                <button onClick={(e) => {
                                    if(typeof props.setActiveCurrency === "function") {
                                        props.setActiveCurrency(props.firstNextCurrency)
                                    }
                                }} className="btn btn-primary">{t("bonus.switch-button", {currencyCode:props.firstNextCurrency})}</button>
                            </>
                        )}
                        {
                            props.firstNextCurrency.length === 0 &&(<p className={"notFound-text"}>{t("bonus.bonusOffersEmpty")}</p>)
                        }
                    </div>
                )}
            </div>
        </>

    )
};

interface NextBonusProps {
    bonus? : BonusConfig;
    dbt? : string;
}
interface Props extends RouteComponentProps {
    openCashier? : () => void;
}
type AllProps = NextBonusProps & Props;

const NextBonusImpl = ( props : AllProps) => {
    const dispatch = useDispatch();
    const openTerms = () => dispatch(setDisplayTermsForBonusConfigId(props.bonus?.id));
    if(!props.bonus){
        return <div/>
    }
    let b = props.bonus;
    const contributions = b.turnoverContributions && b.turnoverContributions.contributions;
    return (
        <AccountCard>
            <div className={"row"}>
                {b.imageUrl && b.imageUrl.trim().length > 0 && (
                    <div className={"col-md-2 image"}>
                        <div className={"bonus-image"} style={{ backgroundImage : `url('${b.imageUrl}')`}}></div>
                    </div>
                )}
                <div className={"col-md-6 content"}>
                    <h4>
                        {b.translations && <Translator defaultTranslation={b.name} translations={b.translations.map(t=>({lng : t.language, value : t.name})) as any} />}
                    </h4>
                    <div className={"text"}>
                        {b.translations && <Translator defaultTranslation={b.summary} translations={b.translations.map(t=>({lng : t.language, value : t.summary})) as any} />}
                    </div>
                    <div className={"bonus-details"}>
                        <a href="#"  onClick={()=> openTerms() } className={"popup-link"}>
                            <i className="material-icons">info</i>{t("bonus.terms.terms-link")}
                        </a>
                        { contributions?.map(c => {
                            const ic = getIconFromProduct(c.product);
                            return <i key={c.id} className={ic.className}>{ic.text}</i>
                        } )}
                    </div>

                </div>
                <div className={"col-md-4 actions"}>
                    <BrandA onClick={()=>props.openCashier?.()} className="btn btn-cta small">{props.dbt}</BrandA>
                </div>
            </div>
        </AccountCard>
    )
}
interface BonusIcon {
    text?: string;
    className?: string;
}

export const getIconFromProduct = (product? :ContributionProduct) : BonusIcon => {
    let icon = "";
    let text = undefined;
    switch (product) {
        case ContributionProduct.CASINO:
            icon = "custom-icons-cherry";
            break;
        case ContributionProduct.SPORTSBOOK:
            icon = "material-icons";
            text = "sports_baseball";
            break;
        case ContributionProduct.POKER:
            icon = "custom-icons-spade";
            break;
        case ContributionProduct.RACING:
            icon = "custom-icons-horse";
            break;
        default:
            icon = "";
            break;
    }
    return { className : icon, text : text};
}
export const NextBonus = connect((app : AppState, props : NextBonusProps) => {

    return {

    }
}, (dispatch => ({ openCashier : ()=> dispatch(showCashier(true))})))(withRouter(NextBonusImpl as any) as any);

